'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _formComponents = require('components/formComponents');

var _strings = require('helpers/strings');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _RecipientStatus = require('components/Recipients/RecipientStatus');

var _RecipientStatus2 = _interopRequireDefault(_RecipientStatus);

var _reactDatetime = require('react-datetime');

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectRecipientsList.scss');

var getDatePickerProps = function getDatePickerProps(recipient) {
  var props = (0, _extends3.default)({}, _formComponents.datePickerProps);
  if (!recipient.expirationDate.unix()) {
    props.timeFormat = false;
    props.dateFormat = '-';
    recipient.expirationDate = (0, _moment2.default)();
  }
  return props;
};

var ProjectRecipientsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ProjectRecipientsListItem, _PureComponent);

  function ProjectRecipientsListItem() {
    (0, _classCallCheck3.default)(this, ProjectRecipientsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientsListItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectRecipientsListItem, [{
    key: 'onUpdateExpirationDate',
    value: function onUpdateExpirationDate(value) {
      var _props = this.props,
          onUpdateExpirationDate = _props.onUpdateExpirationDate,
          recipient = _props.recipient;

      onUpdateExpirationDate({ recipient: recipient, value: value });
    }
  }, {
    key: 'onUpdateDownload',
    value: function onUpdateDownload(e) {
      var _props2 = this.props,
          onUpdateDownload = _props2.onUpdateDownload,
          recipient = _props2.recipient;

      var value = e.target.checked;
      onUpdateDownload({ recipient: recipient, value: value });
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'deleteRecipient',
    value: function deleteRecipient() {
      var _props3 = this.props,
          recipient = _props3.recipient,
          onDelete = _props3.onDelete;

      onDelete(recipient);
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          className = _props4.className,
          recipient = _props4.recipient,
          downloadAuthorised = _props4.downloadAuthorised,
          individualExpiryDate = _props4.individualExpiryDate,
          loadingEditRecipient = _props4.loadingEditRecipient,
          loading = _props4.loading;

      var isRecipientLoading = !!loadingEditRecipient[recipient.recipientId];

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className, styles.recipientRow) },
        _react2.default.createElement(
          'div',
          { className: styles.idColumn },
          recipient.recipientId
        ),
        _react2.default.createElement(
          'div',
          { className: styles.nameColumn },
          (0, _strings.concat)(', ', recipient.fullName, recipient.userEmail)
        ),
        individualExpiryDate && _react2.default.createElement(
          'div',
          { className: styles.dateColumn },
          _react2.default.createElement(_reactDatetime2.default, (0, _extends3.default)({}, getDatePickerProps(recipient), {
            defaultValue: recipient.expirationDate,
            value: recipient.expirationDate,
            onChange: this.onUpdateExpirationDate,
            inputProps: (0, _extends3.default)({}, _formComponents.datePickerProps.inputProps, { disabled: isRecipientLoading })
          }))
        ),
        downloadAuthorised && _react2.default.createElement(
          'div',
          { className: styles.authColumn },
          _react2.default.createElement(_Checkbox2.default, {
            checked: !!recipient.download,
            onChange: this.onUpdateDownload
          }),
          _react2.default.createElement(_Loader2.default, { show: isRecipientLoading, small: true, mask: true })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.statusColumn },
          _react2.default.createElement(_RecipientStatus2.default, { status: recipient.status })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.actionsColumn },
          _react2.default.createElement(_Button2.default, {
            className: (0, _bind2.default)('btn-text', styles.deleteButton),
            onClick: this.deleteRecipient,
            loading: loading,
            small: true
          })
        )
      );
    }
  }]);
  return ProjectRecipientsListItem;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  downloadAuthorised: _propTypes2.default.bool,
  individualExpiryDate: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  loadingEditRecipient: _propTypes2.default.object,
  onDelete: _propTypes2.default.func,
  onUpdateDownload: _propTypes2.default.func,
  onUpdateExpirationDate: _propTypes2.default.func,
  recipient: _propTypes2.default.object
}, _class2.defaultProps = {
  loadingEditRecipient: {},
  onDelete: _noop3.default,
  onUpdateDownload: _noop3.default,
  onUpdateExpirationDate: _noop3.default,
  recipient: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onUpdateExpirationDate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onUpdateExpirationDate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onUpdateDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onUpdateDownload'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteRecipient'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
exports.default = ProjectRecipientsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/ProjectRecipientsList/ProjectRecipientsListItem.js
// module id = 2089
// module chunks = 1